import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicStoreCommunityWeb3: Story = {
  id: 'magic-store-community-web3',
  type: 'CLASSIC',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store Community Web3',
  index: 0,
  content: {
    type: ACTION_TYPES.LOGIN,
    bannerUrl: 'stories/3/main_banner.jpg',
    bannerDeskUrl: 'stories/3/main_banner_desk.jpg',
    buttonText: 'Open account',
    title: 'Unleash the Magic Today!',
    description:
      'What are you waiting for? From project validation and Karma rewards to Hot Offers and thrilling giveaways, every moment in the Magic Store is a step towards an exciting discovery!',
    storyBlocks: [
      {
        bannerUrl: 'stories/3/story_banner_url_1.jpg',
        title: 'Unlock the Magic: Join the Magic Square Community Today!',
        description:
          'Looking for a unique and exciting way to dive into the world of Web3? Discover the Magic Square Community and explore a universe of apps, games, rewards, and more!',
      },
      {
        bannerUrl: 'stories/3/story_banner_url_2.jpg',
        title: 'Discover the Web3 Ecosystem',
        description:
          "Magic Square is not just a store; it's your gateway to the exciting world of Web3. With community-vetted apps, immersive games, and enticing promotions, Magic Square transforms your exploration into an adventure",
      },
      {
        bannerUrl: 'stories/3/story_banner_url_3.jpg',
        title: 'Have a Say with Project Validation',
        description:
          "Be part of the decision-making process with Magic Square's Project Validation. With your input, we determine which projects make it onto our platform. Your voice matters, and together, we shape the future of Web3.",
      },
      {
        bannerUrl: 'stories/3/story_banner_url_4.jpg',
        title: 'Grab Hot Offers and Exclusive Promotions',
        description:
          'From accumulating Karma points to increasing your global Karma score, the Magic Karma Reward Program ensures that your positive actions are recognized and rewarded. Each contribution you make within the Magic Store platform brings you closer to exciting rewards.',
      },
      {
        bannerUrl: 'stories/3/story_banner_url_5.jpg',
        title:
          'Win Big with <a href="https://zealy.io/c/magicsquare/questboard" target="_blank" rel=" noopener noreferrer">Zealy Giveaways</a>',
        description:
          'Join the Magic Square community on Zealy and stand a chance to win a share of the massive 1,000,000 $SQR Prize Pool. An epic quest with a grand reward awaits you!',
      },
      {
        bannerUrl: 'stories/3/story_banner_url_6.jpg',
        title: 'Unleash the Magic Today!',
        description:
          'What are you waiting for? From project validation and Karma rewards to Hot Offers and thrilling giveaways, every moment in the Magic Store is a step towards an exciting discovery! <a href="#story-link-anchor" rel=" noopener noreferrer">Click here</a> to open your account today.',
      },
    ],
  },
};
